function focusFormMessage() {
  const message = document.querySelector('[data-tm-form-message]');
  if (message) message.focus();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', focusFormMessage, { once: true });
else focusFormMessage();

if (window.customElements && !customElements.get('tm-navigation')) {
  customElements.define('tm-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.disclosures = [...this.querySelectorAll('[data-nav-disclosure]')];
      const on = (el, type, fn) => el.addEventListener(type, fn, {signal:this.controller.signal});
      const close = except => this.disclosures.forEach(menu => { if (menu !== except) menu.open = false; });
      this.disclosures.forEach(menu => on(menu, 'toggle', () => { if (menu.open) close(menu); }));
      on(document, 'click', event => { if (!this.contains(event.target) || event.target.closest('a')) close(); });
      on(this, 'keydown', event => {
        if (event.key !== 'Escape') return;
        const menu = this.disclosures.find(item => item.open);
        if (menu) { event.preventDefault(); close(); menu.querySelector('summary').focus({preventScroll:true}); }
      });
      on(this, 'focusout', event => { if (event.relatedTarget && !this.contains(event.relatedTarget)) close(); });
      this.breakpoint = matchMedia('(max-width:990px)');
      on(this.breakpoint, 'change', () => close());
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
